import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCup"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V6H21V13H17V21H3V3ZM17 11.5H19.5V7.5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCup;
